import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import * as styles from './index.module.scss';

import taggingEnvironment from '../../lib/utils/tagging-environments';
import { FooterSections } from './lib/footer-sections';

export const Footer = () => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      allContentfulFooter {
        nodes {
          metadata {
            tags {
              name
            }
          }
          socialLinks {
            title
            url
            image {
              url
            }
          }
          companyLogo {
            image {
              gatsbyImageData(
                width: 1024
                placeholder: BLURRED
                formats: [AVIF, WEBP, AUTO]
              )
              url
              title
            }
            url
          }
          partners {
            url
            image {
              gatsbyImageData(
                width: 1024
                placeholder: BLURRED
                formats: [AVIF, WEBP, AUTO]
              )
              url
              title
            }
          }
          footerLinksList {
            title
            links {
              url
              text
            }
          }
        }
      }
    }
  `);

  const validFooters = data.allContentfulFooter.nodes.filter(node =>
    taggingEnvironment.checkEnvironment(node.metadata.tags)
  );

  const footer = validFooters.find(node =>
    node.metadata?.tags?.some(tag => tag.name === taggingEnvironment.stagingContentfulTag)
  ) || validFooters[0];

  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        <FooterSections data={footer} />
      </div>
    </footer>
  );
}
